import React from "react";
import classNames from "classnames";
import "./styles.css";

/** @params
 * type: underline, outline, text
 */

function Button({
  type = "normal",
  children,
  className = "",
  style,
  onClick = () => {},
}) {
  return (
    <button
      className={classNames("button-component", className, [type])}
      style={style}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default Button;
